import { Accordion } from "flowbite-react"
  const WordpressFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Why should you choose WordPress development services for your upcoming project?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Here is why WordPress is the right choice for your next project - <br/>
                    <ul className="list mb-0 mt-4">
                      <li>High performance</li>
                      <li>Great flexibility</li>
                      <li>Secure and fast</li>
                      <li>Two-way data binding</li>
                      <li>Simple & user-friendly</li>
                      <li>Reliable third-party integration</li>
                      <li>Animations and interactive elements</li>
                      <li>Seamless integration with multiple apps</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the benefits of WordPress Platform?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  WordPress offers a wide range of benefits such as a weightless codebase, easy upgrade, powerful, excellent documentation, faster development, adaptability, and great scalability compared to other technologies.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which applications can you develop using WordPress?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  WordPress can help you develop a variety of web applications, including- <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Team collaboration applications</li>
                      <li>Real-time applications</li>
                      <li>Streaming applications</li>
                      <li>Simple web applications</li>
                      <li>Large scale applications</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Which big Companies use WordPress?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  There are various renowned companies that uses the WordPress platform are Techcrunch, Sony, CNN, Reuters, The NYT, Samsung, Mercedes-Benz, BBC America, Glassdoor, IBM and many others.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How much will it cost for a WordPress development project?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of your project depends on various factors such as the intricacy of your app, the technical expertise of programmers, the experience of developers, features to integrate, total development hours, and more. Please share your exact project requirements so that our team can revert with a project quote. 
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default WordpressFAQ
